import Joyride, { type CallBackProps } from "react-joyride";
import { joyrideLocale, joyrideStyles } from "./joyrideConfig";
import { leaveHistoryTourSteps } from "./leaveHistoryTourSteps";
import { useLeaveTour } from "./useLeaveTour";

const TOUR_STORAGE_KEY = "hr-leave-history-tour-completed";

type LeaveHistoryTourProps = {
  run: boolean;
  onCallback: (data: {
    status?: string;
    type?: string;
    index?: number;
  }) => void;
};

export function LeaveHistoryTour({ run, onCallback }: LeaveHistoryTourProps) {
  const handleCallback = (data: CallBackProps) => {
    onCallback({ status: data.status, type: data.type, index: data.index });
  };

  return (
    <Joyride
      steps={leaveHistoryTourSteps}
      run={run}
      continuous
      showProgress
      showSkipButton
      callback={handleCallback}
      locale={joyrideLocale}
      styles={joyrideStyles}
      scrollToFirstStep
      scrollOffset={24}
      scrollDuration={300}
    />
  );
}

export function useLeaveHistoryTour() {
  return useLeaveTour(TOUR_STORAGE_KEY);
}
